export default __webpack_public_path__ + "static/media/play_faith_pink.a1dbfd3a.svg";